import { withAuth } from '../../auth';
import { ActivityPage } from '../../Activity';

const ActivityWithAuth = withAuth(ActivityPage);

export default ActivityWithAuth;
